

export function typed<Type>(): Type;
export function typed<Type>(def: Type): Type;
export function typed<Type>(def?: Type): Type {
  return def as Type;
}

export type RequireAtLeastOne<T, Keys extends keyof T = keyof T> =
  Pick<T, Exclude<keyof T, Keys>>
  & {
  [K in Keys]-?: Required<Pick<T, K>> & Partial<Pick<T, Exclude<Keys, K>>>
}[Keys]
